{
  "id": "everforest",
  "name": "Everforest",
  "description": "Everforest color scheme - warm and comfortable theme",
  "colors": {
    "light": {
      "primary": "#3A94C5",
      "secondary": "#DF69BA",
      "positive": "#8DA101",
      "negative": "#F85552",
      "warning": "#DFA000",
      "important": "#F57D26",
      "light": "#FDF6E3",
      "dark": "#2D353B",
      "surface": "#F4F0D9",
      "darksurface": "#343F44",
      "white": "#FFFBEF"
    },
    "dark": {
      "primary": "#7FBBB3",
      "secondary": "#D699B6",
      "positive": "#A7C080",
      "negative": "#E67E80",
      "warning": "#DBBC7F",
      "important": "#E69875",
      "light": "#FFFFFF",
      "dark": "#2D353B",
      "surface": "#F4F0D9",
      "darksurface": "#343F44",
      "white": "#EFEBD4"
    }
  }
}
